export const UGI_CONTACT = {
  address: "Hyderabad, Telangana, India",
  email: "info@unitygatewayinternational.com",
  phone: "+91 9059832121",
  whatsapp: ["+91 9059836868", "+91 9059837272"],
};

export const UGI_SOCIAL_LINKS = [
  { id: "instagram", label: "Instagram", href: process.env.REACT_APP_UGI_INSTAGRAM_URL || "" },
  { id: "facebook", label: "Facebook", href: process.env.REACT_APP_UGI_FACEBOOK_URL || "" },
  { id: "linkedin", label: "LinkedIn", href: process.env.REACT_APP_UGI_LINKEDIN_URL || "" },
  { id: "x", label: "X", href: process.env.REACT_APP_UGI_X_URL || "" },
  { id: "youtube", label: "YouTube", href: process.env.REACT_APP_UGI_YOUTUBE_URL || "" },
];
